import { CartDialogComponent } from './../cart-dialog/cart-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CartService } from './../cart.service';
import { Cart } from './../cart.model';
import { BaseEntityListComponent } from './../base-entity-list.component';
import { Component } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-carts',
  templateUrl: './carts.component.html',
  styleUrls: ['./carts.component.css']
})
export class CartsComponent extends BaseEntityListComponent<Cart> {

  searchTerm: string;
  searchTermChanged: Subject<string> = new Subject<string>();

  displayedColumns = ["id", "email", "fullName", "destination", "nDays", "plan", "status"];

  constructor(private dialog: MatDialog, private cartService: CartService, private snackBar: MatSnackBar) {
    super(Cart, cartService, snackBar);
    this.searchTermChanged.pipe(debounceTime(250)).pipe(distinctUntilChanged()).subscribe(_ => this.list());
  }

  list() {
    if (this.searchTerm) {
      if (this.searchTerm.indexOf("@") >= 0) {
        this.cartService.listWhereEmail(this.searchTerm.trim()).subscribe((entities: Cart[]) => this.dataSource.data = entities);
      } else {
        this.cartService.get(this.searchTerm.trim()).subscribe((entity: Cart) => this.dataSource.data = [entity]);
      }

    } else {
      this.dataSource.data = [];
    }
  }

  edit(cart: Cart) {
    this.dialog.open(CartDialogComponent, {
      width: '50%',
      data: cart
    });
  }

}
